import { Routes } from '@angular/router';
import { gcomMatchGuard } from './_shared/guards/gcom-match.guard';

export const routes: Routes = [
  {
    path: 'affiliations',
    loadChildren: () =>
      import('./demandes-affiliation/routes').then(r => r.DEMANDES_AFFILIATION_ROUTES),
  },
  {
    path: 'habilitations',
    loadChildren: () =>
      import('./demandes-habilitation/routes').then(r => r.DEMANDES_HABILITATION_ROUTES),
  },
  {
    path: 'depot-de-pieces',
    canMatch: [gcomMatchGuard(false)],
    loadChildren: () =>
      import('./demandes-validation-pj/routes').then(
        r => r.DEMANDES_VALIDATION_PJ_ROUTES
      ),
  },
  {
    path: 'depot-de-pieces-gcom',
    canMatch: [gcomMatchGuard(true)],
    loadChildren: () =>
      import('./demandes-validation-pj/routes').then(
        r => r.DEMANDES_VALIDATION_PJ_ROUTES_GCOM
      ),
  },
  {
    path: 'renouvellements',
    loadChildren: () =>
      import('./renouvellements/routes').then(r => r.RENOUVELLEMENT_ROUTES),
  },
  {
    path: 'consultants',
    loadChildren: () => import('./consultants/routes').then(r => r.CONSULTANTS_ROUTES),
  },
  {
    path: 'resiliations',
    loadChildren: () => import('./resiliations/routes').then(r => r.RESILIATION_ROUTES),
  },
  { path: '**', redirectTo: '/consultants' },
];
